(() => {
    'use strict';

    if (!real.dom.$body.hasClass('validate-login-link')) {
        return;
    }

    $('.send-btn').on('click', e => {
        const btn = $(e.target);
        real.button.loading(btn);

        real.ajax.json(real.baseUri + '/sessions/send-pin/' + btn.data('login-link-uid'), {
            type : 'POST',
            waitForWebsocket : false,
            showErrorNotification : false,
            success : () => {
                $('.pin-send').addClass('d-none');
                $('.pin-entry').removeClass('d-none');
                $('.howspace-form-otp-input .howspace-form-number-input')[0]?.focus();
            },
            complete : () => {
                real.button.reset(btn);
            }
        });
    });

    $('.resend-btn').on('click', () => {
        $('.pin-send').removeClass('d-none');
        $('.pin-entry').addClass('d-none');
        howspace.components.otpInput.reset($('.howspace-form-otp-input'));
    });
})();
